import React from 'react';
import styled from 'styled-components';
import SoftwareHero from './SoftwareHero';
import SoftwareFeatures from './SoftwareFeatures';
import SoftwarePricing from './SoftwarePricing';
import SoftwareTestimonials from './SoftwareTestimonials';
import SoftwareIdealClient from './SoftwareIdealClient';
import SoftwareFAQ from './SoftwareFAQ';
import SoftwareCTA from './SoftwareCTA';
import SoftwareLogoStrip from './SoftwareLogoStrip';
import SoftwareTopLogoStrip from './SoftwareTopLogoStrip';

function SoftwarePage() {
  return (
    <SoftwarePageContainer>
      <SoftwareHero />
      <SoftwareTopLogoStrip />
      <SoftwareFeatures />
      <SoftwareLogoStrip />
      <SoftwarePricing />
      <SoftwareTestimonials />
      <SoftwareIdealClient />
      <SoftwareFAQ />
      <SoftwareCTA />
    </SoftwarePageContainer>
  );
}

const SoftwarePageContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  background-color: #f8f9fa;
`;

export default SoftwarePage; 